export const ScrollPosts = page => ({
  type: 'FETCH_POSTS_SCROLL',
  payload: page,
});

export const ScrollImpressions = page => ({
  type: 'FETCH_IMPRESSIONS_SCROLL',
  payload: page,
});
